import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const slug = (
  // There is no slug if we show the kernel editor prior to kernel load.
  state: string | null = null,
  action: NotebookAction
): string | null => {
  switch (action.type) {
    case NotebookActionKey.SET_KERNEL_SPEC:
      return action.payload.slug;
    case NotebookActionKey.SET_SLUG:
      return action.payload.slug;
    default:
      return state;
  }
};
